import {FormInput} from "../../Form/Input/FormInput";
import {i18n} from "../../../Utils/i18n/i18n";
import React, {useState, useEffect} from "react";
import './EditOrganization.scss'
import {buttonColors} from "../../Pickers/InputTheme";
import {Button} from "../../Form/Button/Button";
import {updateOrganizationNameApi} from "../../../Services/api";
import {get} from "lodash";

export const EditOrganization = ({organization, onSaveExternal=null}) => {
    const [orgName, setOrgName] = useState('')

    useEffect(() => {
        setOrgName(get(organization, "organization.orgName"))
    }, [organization])

    const onSave = async() => {
        const newOrganization = await updateOrganizationNameApi({
            orgName,
            orgId: get(organization, "organization.id")
        })
        setOrgName(newOrganization.orgName)
        if (onSaveExternal) {
            onSaveExternal(newOrganization)
        }
    }

    const onEditOrgName = (event) => {
        setOrgName(event.target.value)
    }
    return <div className="EditOrganization">
        <div className="orgName">
            <FormInput
                id={`noteContent-${get(organization, "id")}`}
                label={i18n.translate('organization.organizationName')}
                className=""
                value={orgName}
                onChange={onEditOrgName}
            />
        </div>
        <div className="saveContainer">
            <Button
                color={buttonColors.GREY}
                onClick={onSave}
                text={i18n.translate('general.saveChanges')}
            />

        </div>
    </div>
}